























































































import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { Route } from 'vue-router';
import { Dialog, Notify } from 'vant';
@Component({
  components: {},
})
export default class ProblemList extends Vue {
  @Prop() classInfo: any;

  loading: boolean = false;

  finished: boolean = false;

  problemList: any[] = [];

  @Ref() problemRef: HTMLDivElement;

  listData: any = [];
  get ProblemImportance() {
    return models.ProblemImportance;
  }

  async getListData() {
    this.loading = true;
    try {
      const { data } = await api.Problem.findByClassIdAndUserId_GET({ classId: this.classInfo.id });
      this.problemList = data;
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }

  /**跳转详情 */
  listDetail(item) {
    this.$router.push({
      name: 'AddQuestion',
      query: {
        info: JSON.stringify(item),
        type: 'readonly',
      },
    });
  }

  delProblem(id: string) {
    Dialog.confirm({
      title: '提示 ',
      message: '您确定要删除此条记录吗',
    })
      .then(async () => {
        const { data, success, message } = await api.Problem.deleteByIds_POST({
          ids: [id],
        });
        if (success) {
          const idx = this.problemList.findIndex(item => item.id === id);
          this.problemList.splice(idx, 1);
          Notify({ type: 'primary', message: '删除成功' });
        } else {
          Notify({ type: 'danger', message: '删除失败' });
        }
      })
      .catch(() => {});
  }
  mounted() {
    this.getListData();
    this.$router.beforeEach((to: Route, from: Route, next: any) => {
      if (from.path.includes('/add-question') && to.path.includes('/myTraining/detail')) this.getListData();
      next();
    });
  }
}
